/**
 * Port Polska area styling shared by the main map layer and the parcel report
 * map, so both draw the same kinds in the same colours as the legend.
 */
export const PORT_POLSKA_AREAS_PATH = 'api/rezerwacje-port-polska';

// Colours of the source service legend (GetLegendGraphic), kept for recognisability.
export const PORT_POLSKA_KIND_STYLES = {
    reservation_plan: { color: '#faa280', outline: '#d9653a', fillOpacity: 0.45 },
    investment_ban: { color: '#71d1e1', outline: '#2b8fa1', fillOpacity: 0.4 },
    investment_ban_preemption: { color: '#a9c179', outline: '#62802b', fillOpacity: 0.4 },
    // A research-only right: outline without fill, so it does not hide the bans inside.
    research_right: { color: '#7a5aa6', outline: '#7a5aa6', fillOpacity: 0 },
};
const OUTLINE_WIDTH = 1.5;
const RESEARCH_DASH = [3, 2];
const FALLBACK_COLOR = '#888888';
const FALLBACK_FILL_OPACITY = 0.3;

const kindMatch = (property, fallback) => ['match', ['get', 'kind'],
    ...Object.entries(PORT_POLSKA_KIND_STYLES).flatMap(([kind, style]) => [kind, style[property]]),
    fallback];

/** MapLibre layer definitions (fill, outline, dashed research outline) for one GeoJSON source. */
export function portPolskaLayerDefinitions(sourceId, idPrefix, minZoom = 0) {
    return [
        {
            id: idPrefix + '-fill', type: 'fill', source: sourceId, minzoom: minZoom,
            paint: { 'fill-color': kindMatch('color', FALLBACK_COLOR), 'fill-opacity': kindMatch('fillOpacity', FALLBACK_FILL_OPACITY) },
        },
        {
            id: idPrefix + '-line', type: 'line', source: sourceId, minzoom: minZoom,
            filter: ['!=', ['get', 'kind'], 'research_right'],
            paint: { 'line-color': kindMatch('outline', FALLBACK_COLOR), 'line-width': OUTLINE_WIDTH },
        },
        {
            id: idPrefix + '-line-research', type: 'line', source: sourceId, minzoom: minZoom,
            filter: ['==', ['get', 'kind'], 'research_right'],
            paint: { 'line-color': PORT_POLSKA_KIND_STYLES.research_right.outline, 'line-width': OUTLINE_WIDTH, 'line-dasharray': RESEARCH_DASH },
        },
    ];
}
